import { render, staticRenderFns } from "./model3.vue?vue&type=template&id=7fbc121a&scoped=true"
import script from "./model3.vue?vue&type=script&lang=js"
export * from "./model3.vue?vue&type=script&lang=js"
import style0 from "./model3.vue?vue&type=style&index=0&id=7fbc121a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc121a",
  null
  
)

export default component.exports